import 'slick';

( function( $ ) {
	'use strict';

	// alternating features slider
	$( '.trends-slider' ).slick( {
		arrows: true,
		dots: false,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 300,
		mobileFirst: true,
		swipe: true,
		fade: false,
		autoplay: false,
		adaptiveHeight: false,
		prevArrow:'<div class=\'mts-prev\'>',
		nextArrow:'<div class=\'mts-next\'>',
		responsive: [
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 2
				}
			}
		]
	} );

} )( jQuery );
